import React from "react"
import { Box } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import { skuGroupDrawerFilters, skuGroupDetailModalFilters } from "../../@signals"


export default function actionsColumn(onDelete) {
    return {
        name: 'name', label: 'Name',
        options: {
            headerAlign: 'center',
            setCellProps: () => ({ sx: { textAlign: 'center' } }),
            customBodyRowRender: (value, row) => <ActionsCell value={value} row={row} onDelete={onDelete} />
        }
    }
}

const ActionsCell = ({ value, row, onDelete }) => (
    <Box>
        {value}
        <Box display="flex" justifyContent="center" sx={{ mt: 0.5 }}>
            <IconSeeker
                icon="circle-info"
                tooltip="See group details"
                sx={{ fontSize: '1rem', cursor: 'pointer' }}
                onClick={() => { skuGroupDetailModalFilters.value = row }}
            />
            <IconSeeker
                icon="pen"
                tooltip="Edit group"
                sx={{ ml: 2, fontSize: '1rem', cursor: 'pointer' }}
                onClick={() => {
                    skuGroupDrawerFilters.value = { mode: 'edit', ...row }
                }}
            />
            <IconSeeker
                icon="trash"
                tooltip="Delete group"
                sx={{ ml: 2, fontSize: '1rem', cursor: 'pointer' }}
                onClick={() => onDelete(row)}
            />
        </Box>
    </Box>
)
